import React, { useState, useEffect } from 'react'

import { Input } from '@/ui'

import styles from './index.less'

export default ({ value, onChange, clearClass, ...restProps }) => {
    const [input, setInput] = useState(value)

    useEffect(() => {
        setInput(value)
    }, [value])

    return (
        <Input.Search
            allowClear
            className={clearClass ? '' : styles.container}
            value={input}
            onChange={({ target: { value } }) => setInput(value)}
            onSearch={onChange}
            {...restProps}
        />
    )
}
